/**
 * Placeholders an email subject or body may use; filled in when the email is sent (the Inspection
 * Scheduled email: ScheduleService / twin-ci Email_model; canned replies: the Document Manager).
 * One list for the Appointment Emails and Canned Replies editors.
 */
export const EMAIL_PLACEHOLDERS: [string, string][] = [
    ['[@INSPECTOR_PHOTO]', 'Inspector Photo'], ['[@INSPECTOR_NAME]', 'Inspector Name'],
    ['[@INSPECTOR_PHONE]', 'Inspector Phone'], ['[@IADDR]', 'Property Address'], ['[@ICITY]', 'Property City'],
    ['[@ISTATE]', 'Property State'], ['[@IZIP]', 'Property Zip Code'], ['[@INSPDATE]', 'Inspection Date'],
    ['[@INSPTIME]', 'Inspection Time'], ['[@FEE]', 'Fees'], ['[@CEMAIL]', 'Client Email'], ['[@CNAME]', 'Client Name'],
    ['[@CFIRST_NAME]', 'Client First Name'], ['[@CLAST_NAME]', 'Client Last Name'],
];
